module.exports = __webpack_public_path__ + "img/icon_qiuzhi01.f1ea33f5.png";